export class Country {
    public key: string;
    public name: string;
    public countryGroupKey: string;
}